import { Box, Typography } from "@mui/material";
import { type FC, memo } from "react";
import { useHospitalData } from "../../../contexts/HospitalDataProvider";
import { getStatusColor } from "../../../pages/SynergyModeStaffing/Cells/ActiveTimeOffRequest/TimeOffRequestDialog";
import { formatWeekRangeWithMonth } from "../../../utils/dateFormatting";
import { type TimeOffRequest, TimeOffRequestReason, TimeOffRequestStatus } from "../../../utils/models";

type TimeOffRequestCardProps = {
	request: TimeOffRequest;
	onClick: (request: TimeOffRequest) => void;
};

export const TimeOffRequestCard: FC<TimeOffRequestCardProps> = memo(({ request, onClick }) => {
	const { getNurseFormattedName, getNurseById } = useHospitalData();
	const nurse = getNurseById(request.requestingStaffId);
	const nurseName = nurse ? getNurseFormattedName(nurse.id) : "Unknown Staff";
	const isPending = request.status === TimeOffRequestStatus.PENDING;

	return (
		<Box
			onClick={isPending ? () => onClick(request) : undefined}
			sx={{
				p: 2,
				mb: 1,
				border: "1px solid #E3E4F0",
				borderRadius: 2,
				backgroundColor: "#fff",
				cursor: isPending ? "pointer" : "default",
				transition: "all 0.15s ease-in-out",
				...(isPending && {
					"&:hover": {
						borderColor: "primary.main",
						boxShadow: "0 2px 8px rgba(75, 70, 130, 0.12)",
					},
				}),
			}}
		>
			<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 0.5 }}>
				<Typography sx={{ fontSize: "14px", fontWeight: 600, color: "primary.dark" }}>{nurseName}</Typography>
				<Typography
					sx={{
						fontSize: "12px",
						fontWeight: 600,
						color: getStatusColor(request.status),
						textTransform: "capitalize",
					}}
				>
					{request.status}
				</Typography>
			</Box>
			<Typography sx={{ fontSize: "13px", color: "primary.dark" }}>{formatWeekRangeWithMonth(request.startDate, request.endDate, true, true)}</Typography>
			<Typography sx={{ fontSize: "12px", color: "#757575", mt: 0.25 }}>
				{request.reason !== TimeOffRequestReason.Other ? request.reason : request.reasonExplanation}
			</Typography>
		</Box>
	);
});
